<template>
  <InputRadioGroup legend="Minnesstorlek" type-class="product-page">
    <InputRadioButton
      v-for="storage in store.storageOptionsWithThisColor"
      :id="'Minnesstorlek' + storage"
      :key="'Minnesstorlek' + storage"
      v-model="store.productState.selectedStorage"
      :value="storage"
      :label="storage"
      :simple-label="true"
      :group-name="`storage-${groupNameId}`"
      @update:model-value="store.changeOption('storage')"
    />
  </InputRadioGroup>
</template>

<script lang="ts" setup>
const store = useMyProductPageStore();
const groupNameId = useId();
</script>

<style></style>
